import { type SubtypeSectionProps, subtypeControls } from "./support";
import { fieldGrid } from "../../components/styles";

export const villaFieldLabels = {
  bedrooms: "Bedrooms",
  bathrooms: "Bathrooms",
  maxGuests: "Maximum guests",
  minimumStayNights: "Minimum stay (nights)",
  checkInTime: "Check-in time",
  checkOutTime: "Check-out time",
} as const;

export function VillaSection(props: SubtypeSectionProps) {
  const c = subtypeControls(props);
  return (
    <div className={fieldGrid}>
      {c.whole("bedrooms", villaFieldLabels.bedrooms)}
      {c.whole("bathrooms", villaFieldLabels.bathrooms)}
      {c.whole("maxGuests", villaFieldLabels.maxGuests, { hint: "From 1 to 100." })}
      {c.whole("minimumStayNights", villaFieldLabels.minimumStayNights)}
      {c.time("checkInTime", villaFieldLabels.checkInTime, {
        hint: "Local time. The item needs a time zone in Details.",
      })}
      {c.time("checkOutTime", villaFieldLabels.checkOutTime)}
    </div>
  );
}
